

import React from 'react';
import './commentsection.css';

const CommentShimmer = () => {
  return (
    <div className="mr-comment-shimmer-row" aria-hidden="true">
      {/* Avatar Circle */}
      <div className="mr-comment-shimmer-avatar agenda-shimmer-block" />

      {/* Main Bubble & Content */}
      <div className="mr-comment-shimmer-body">
        <div className="mr-comment-shimmer-bubble">
          <div className="d-flex align-items-center justify-content-between mb-2">
            <div className="mr-comment-shimmer-name agenda-shimmer-block" />
            <div className="mr-comment-shimmer-time agenda-shimmer-block" />
          </div>
          <div className="mr-comment-shimmer-line agenda-shimmer-block mb-1-5" style={{ width: '90%' }} />
          <div className="mr-comment-shimmer-line agenda-shimmer-block" style={{ width: '60%' }} />
        </div>

        {/* Action Pills */}
        <div className="mr-comment-shimmer-actions">
          <div className="mr-comment-shimmer-btn agenda-shimmer-block" />
          <div className="mr-comment-shimmer-btn agenda-shimmer-block" />
        </div>
      </div>
    </div>
  );
};

export default CommentShimmer;

